import { render, staticRenderFns } from "./special.vue?vue&type=template&id=2b73ed05&scoped=true&"
import script from "./special.vue?vue&type=script&lang=js&"
export * from "./special.vue?vue&type=script&lang=js&"
import style0 from "./special.vue?vue&type=style&index=0&id=2b73ed05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b73ed05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
